import CommissionDetails from "./CommissionDetails";
import CommissionList from "./CommissionList";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";

const CommissionsTab = () => {

    const { id } = useParams();

    
    return (
        <Container className='d-flex gap-2 p-0 mb-3'>
            <CommissionList selectedRequest={id} />
            {
                (!id) ? (
                    <div className='bg-dark flex-center flex-column gap-2 col-7 rounded-bottom'>
                        <box-icon color='white' size='lg' type='solid' name='info-circle'></box-icon>
                        <p className='text-center'>Select a request to view its details</p>
                    </div>
                ) : <CommissionDetails id={id} />
            }
        </Container>
    );
};


export default CommissionsTab;